import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHTTPHandlerService } from '@services/httpClientAbstract/httpClient.service.abstract';
import {
	BusinessSignUpRequestModel,
	BusinessSignUpRequestPayload,
} from '@models/businessSignUpRequests';

@Injectable({
	providedIn: 'root',
})
export class BusinessSignUpRequestService extends BaseHTTPHandlerService {
	basePath = 'businesssignuprequest';

	create = (request: BusinessSignUpRequestPayload): Observable<boolean> => {
		return this.post<boolean>('create', request);
	};

	get = <T = BusinessSignUpRequestModel>(id: string) => super.get<T>(id);
}
